import API from 'services/api';

import { IPaymentListItem } from '../models';

interface IProps {
  paymentId: string;
  payload: IPayload;
}

interface IPayload {
  paymentMethodCode: string;
  dateOfPayment: string | null;
  paidAmount?: number | null;
}

export const updateReservationPaymentStatus = ({
  paymentId,
  payload,
}: IProps): Promise<IPaymentListItem> =>
  API.post(`api/accommodation/calculations/payments/${paymentId}/paid`, payload).then(
    response => response?.data,
  );
